// extracted by mini-css-extract-plugin
module.exports = {"main_menu":"MainMenu_main_menu__3aKc0"};